module.exports = __webpack_public_path__ + "static/media/Standard_Chartered.041446c1.svg";